import Link from "next/link";

export default function ContactInfo() {
  return (
    <div className="relative h-full w-full px-5 pr-0 lg:p-20">
      <div className="relative -top-5 flex h-[372px] items-center rounded-xl bg-[#F5B119] px-4 lg:px-8">
        <img
          src="/images/contact-atribut-1.webp"
          alt="atribut"
          className="absolute -top-8 -left-8 z-0 "
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = "/images/contact-atribut-1.png";
          }}
        />
        <img
          src="/images/contact-atribut-2.webp"
          alt="atribut"
          className="absolute -bottom-6 -right-4 z-0 "
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = "/images/contact-atribut-2.png";
          }}
        />
        <div className="space-y-2">
          <div className="flex items-center">
            <img
              src="/images/contact-wa.webp"
              alt="whatsapp"
              className="pr-2"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "/images/contact-wa.png";
              }}
            />
            <p className="font-nunito text-lg font-bold">+62 8119393995</p>
          </div>
          <div className="flex items-center">
            <img
              src="/images/contact-email.webp"
              alt="email"
              className="pr-2"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "/images/contact-email.png";
              }}
            />
            <p className="font-nunito text-lg font-bold">
              wardayacollege@gmail.com
            </p>
          </div>
          <div className="flex items-start">
            <img
              src="/images/contact-lokasi.webp"
              alt="maps"
              className="pr-2"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "/images/contact-lokasi.png";
              }}
            />
            <div className="mt-4">
              <p className="font-nunito text-lg font-bold">Wardaya College</p>
              <Link href="https://goo.gl/maps/mkk5VGzTxD2Sfm1h6">
                <a
                  className="cursor-pointer font-nunito text-lg font-bold"
                  target="_blank"
                >
                  Taman Ratu Indah, Blok. F No. 7, RT.10/RW.13, Duri Kepa, Kec.
                  Kb. Jeruk, Daerah Khusus Ibukota Jakarta 11510
                </a>
              </Link>
              <p className="font-nunito text-lg font-bold">
                {" "}
                Tel : 021-21197608
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
